<template>
  <div class="boss-user-info">
    <div class="boss-user-info-left">
      <div
        class="boss-send-target"
        data-test="target-count"
      >
        送信対象（{{ checkedMemberCount }}名）
      </div>
      <div class="vertical boss-send-target-info">
        <div
          v-for="(member, index) in renderingMembers"
          :key="index"
          :class="{ 'is-active': currentUserIndex == index }"
          class="boss-send-target-item"
        >
          <span
            v-show="canShowUser(member.checked)"
            :data-test="'user-info-' + index"
            class="boss-user-data"
            @click="selectUser(index)"
          >
            <input
              v-if="isEdit"
              :checked="member.checked"
              :value="member.id"
              type="checkbox"
              class="boss-input-checkbox margin-auto"
              :data-test="'user-check-' + index"
              @change="onUserChecked(!member.checked, index)"
            >
            <div class="boss-user-data-left">
              <span
                data-test="img-click"
                @click="isEdit ? onUserChecked(!member.checked, index) : ''"
              >
                <img
                  v-if="isNew(member)"
                  :alt="'ID:' + member.id"
                  data-test="boss-avatar-new"
                  class="boss-user-data-image pega-margin-x-3"
                  src="@/assets/images/boss-avatar-new.svg"
                >
                <img
                  v-else
                  :alt="'ID:' + member.id"
                  data-test="boss-avatar"
                  class="boss-user-data-image pega-margin-x-3"
                  src="@/assets/images/boss-avatar.svg"
                >
              </span>
              <div class="boss-user-data-id">
                <span>ID:{{ member.id }}</span>
                <div
                  v-if="!member.checked"
                  class="boss-annotation-text font-size-1-3em"
                >
                  送信対象外
                </div>
              </div>
            </div>
            <scout-resume-member-summary
              class="boss-user-data-right display-block margin-auto width-100"
              :member="member"
            />
          </span>
        </div>
        <infinity-scroll
          :objects="members"
          :infinity-objects.sync="renderingMembers"
          :number="infinityScrollNumber"
        />
      </div>
    </div>
    <div class="boss-user-info-right">
      <div class="boss-user-resume">
        会員レジュメ
      </div>
      <div class="boss-tabs-content-resume">
        <div
          v-for="(member, index) in renderingMembers"
          :key="index"
          :class="{ 'is-active': currentUserIndex == index }"
          class="boss-tabs-content-wrap"
        >
          <!-- ▼職務経歴書 -->
          <scout-member-career-resume :member="member" />
          <!-- ▲職務経歴書 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ScoutResumeMemberSummary from '@/components/atoms/ScoutResumeMemberSummary'
import ScoutMemberCareerResume from '@/components/molecules/ScoutMemberCareerResume'
import InfinityScroll from '@/components/atoms/InfinityScroll'
import dayjs from 'dayjs'

export default {
  components: { ScoutResumeMemberSummary, ScoutMemberCareerResume, InfinityScroll },
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    members: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      currentUserIndex: 0,
      renderingMembers: []
    }
  },
  computed: {
    infinityScrollNumber: () => 20,
    checkedMemberCount () {
      return _(this.members).filter('checked').value().length
    }
  },
  methods: {
    selectUser (index) {
      this.$set(this, 'currentUserIndex', index)
    },
    isNew (member) {
      return dayjs(dayjs().subtract(10, 'days')).isSameOrBefore(
        dayjs(member.recentActionDate, 'YYYY/MM/DD hh:mm:ss'), 'day')
    },
    onUserChecked (checked, index) {
      this.$emit('setUserChecked', checked, index)
    },
    canShowUser (checked) {
      return this.isEdit || checked
    }
  }
}
</script>
